export enum OccupancyRentalV2MenuEnum {
    overview = 0,
    residentialUnitsGradeWise,
    residentialUnitsTypeWise,
    commercialUnitsGradeWise,
    commercialUnitsSizeWise,
    unitRentalTransaction,
    unit,
    unitTransaction
}